import React from 'react';
import PropTypes from 'prop-types';
import './billboard.scss';

const Billboard = ({ title, children }) => {
  return (
    <section className="billboard--container">
      <section className="billboard__title">{title}</section>
      <section className="billboard__content">{children}</section>
    </section>
  );
};

Billboard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
};

export default Billboard;
